<template>
	<modal ref="modalOk">
		<button type="button" class="close" @click="clickVoltar()">
			<span aria-hidden="true">&times;</span>
		</button>
		<h4 class="modal-title">
			{{ titulo.toUpperCase() }}
		</h4>

		<hr />

		<h2 class="text-center text-success"><i class="fa fa-check-circle"></i> {{ textoSucesso.toUpperCase() }}</h2>

		<h2 class="text-center">
			<strong>{{ descricao }}</strong>
		</h2>

		<button class="btn btn-default" type="button" @click="clickVoltar">
			<i class="icon-left"></i> {{ _traducao('menuAGcadAluno', 'voltarParaLista') }}
		</button>

		<button
			class="btn btn-default pull-right"
			type="button"
			@click="clickModalVisualizarImpressao"
			v-if="modalExibeVisualizarImpressao"
		>
			<i class="icon-imprimir"></i> {{ _traducao('global', 'imprimir') }}
		</button>
	</modal>
</template>

<script>
export default {
	props: {
		titulo: {
			type: String,
			required: true
		},
		textoSucesso: {
			type: String,
			required: true
		},
		descricao: {
			type: String,
			required: false,
			default: ''
		},
		rotaVoltar: {
			type: String,
			required: true
		},
		abrir: {
			type: Boolean,
			default: false
		},
		modalExibeVisualizarImpressao: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	watch: {
		abrir(newValue, oldValue) {
			if (oldValue != newValue) {
				if (newValue) {
					this.$refs.modalOk.modalShow()
				}
			}
		}
	},
	methods: {
		clickVoltar() {
			this.$refs.modalOk.modalHide()
			this.$router.push({name: this.rotaVoltar})
		},
		clickModalVisualizarImpressao() {
			this.$refs.modalOk.modalHide()
			this.$emit('click-modal-visualizar-impressao')
		}
	}
}
</script>